import { axiosInstanceBatchCredit } from "../axios";
import {
  AppServiceCreate,
  AppServiceCreations,
  RequestResponse
} from "../types";

export const createAppService = async (
  payload: AppServiceCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceBatchCredit.post("/api/application/create", payload);
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to create app service: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const getServices = async (
  pageNumber: number,
  pageSize: number,
  appId: string,
  consumerQueue: string
): Promise<
  RequestResponse<{
    records: AppServiceCreations[];
    total: number;
    responseCode: string;
    responseMessage: string;
  }>
> => {
  try {
    let endpoint = "/api/application/all";

    const params: any = {
      page: pageNumber,
      size: pageSize
    };

    if (appId) {
      params.appId = appId;
      endpoint = "/api/application/filter";
    }

    if (consumerQueue) {
      params.consumerQueue = consumerQueue;
      endpoint = "/api/application/filter";
    }

    const response = await axiosInstanceBatchCredit.get(endpoint, {
      params
    });

    return {
      error: false,
      data: {
        records: response.data.data,
        total: response.data.count,
        responseCode: response.data.responseCode,
        responseMessage: response.data.responseMessage
      }
    };
  } catch (err) {
    console.error("Unable to fetch agents: ", err);
    const errorResponse = err.response?.data;
    return {
      error: true,
      message:
        errorResponse?.responseMessage ||
        errorResponse?.message ||
        err.message ||
        err,
      data: errorResponse || null
    };
  }
};

export const updateAppService = async (
  id: number,
  payload: AppServiceCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceBatchCredit.put(
      `/api/application/update`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to update agent: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
